/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { ETypeContrat } from './ETypeContrat';
import {
    ETypeContratFromJSON,
    ETypeContratFromJSONTyped,
    ETypeContratToJSON,
} from './ETypeContrat';

/**
 * 
 * @export
 * @interface EListSearchTypeETypeContratNullableCombinableCriteria
 */
export interface EListSearchTypeETypeContratNullableCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeETypeContratNullableCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {ETypeContrat}
     * @memberof EListSearchTypeETypeContratNullableCombinableCriteria
     */
    value?: ETypeContrat;
    /**
     * 
     * @type {ETypeContrat}
     * @memberof EListSearchTypeETypeContratNullableCombinableCriteria
     */
    secondaryValue?: ETypeContrat;
}

/**
 * Check if a given object implements the EListSearchTypeETypeContratNullableCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeETypeContratNullableCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeETypeContratNullableCombinableCriteriaFromJSON(json: any): EListSearchTypeETypeContratNullableCombinableCriteria {
    return EListSearchTypeETypeContratNullableCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeETypeContratNullableCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeETypeContratNullableCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : ETypeContratFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : ETypeContratFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeETypeContratNullableCombinableCriteriaToJSON(value?: EListSearchTypeETypeContratNullableCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': ETypeContratToJSON(value.value),
        'secondaryValue': ETypeContratToJSON(value.secondaryValue),
    };
}

